module.exports = __webpack_public_path__ + "static/media/BuildYourBingingBrand.b1c803c5.png";